// const config = {
//   apiKey: "AIzaSyCRuyHwa9pXxru5ISMcE5TRqbU4tzIuzwg",
//   authDomain: "sya-dev.firebaseapp.com",
//   databaseURL: "https://sya-dev.firebaseio.com",
//   projectId: "sya-dev",
//   storageBucket: "sya-dev.appspot.com",
//   messagingSenderId: "164082581990"
//     }
//   export default config

const config = {
  apiKey: 'AIzaSyDB9Jj5Fvm6Q6ee9-CPMSz0MU_1M1jeUS0',
  authDomain: 'sya-app.firebaseapp.com',
  databaseURL: 'https://sya-app.firebaseio.com',
  projectId: 'sya-app',
  storageBucket: 'sya-app.appspot.com'
}
export default config





// WEBPACK FOOTER //
// ./src/config.js